<div class="modal" data-id="cd-modal" hidden>
  <div class="modal__backdrop" data-id="cd-backdrop"></div>

  <div class="modal__dialog" role="dialog" aria-modal="true" aria-labelledby="cd-title">
    <header class="modal__header">
      <h2 class="modal__title" id="cd-title"><%= _lcs( 'Benutzerdetails' ) %></h2>
      <button type="button" class="iconbtn modal__close" data-id="cd-close" aria-label="<%= _lcs( 'Schließen' ) %>">
        <i class="icon icon--x"></i>
      </button>
    </header>

    <div class="modal__body">
      <dl class="modal__dl">
        <dt><%= _lcs( 'Name' ) %></dt><dd data-id="cd-name">—</dd>
        <dt><%= _lcs( 'Firmenname' ) %></dt><dd data-id="cd-company">—</dd>
        <dt><%= _lcs( 'E-Mail' ) %></dt><dd data-id="cd-email">—</dd>
        <dt><%= _lcs( 'Rollen' ) %></dt><dd data-id="cd-roles">—</dd>
        <dt><%= _lcs( 'Status' ) %></dt><dd data-id="cd-status">—</dd>
        <dt><%= _lcs( 'Unterkünfte' ) %></dt><dd data-id="cd-accommodations">—</dd>
        <dt><%= _lcs( 'Erstellt am' ) %></dt><dd data-id="cd-created">—</dd>
        <dt><%= _lcs( 'Aktualisiert am' ) %></dt><dd data-id="cd-updated">—</dd>
        <dt>ID</dt><dd data-id="cd-id" class="modal__dl-mono">—</dd>
      </dl>
    </div>

    <footer class="modal__footer">
      <button type="button" class="btn btn--ghost btn--sm" data-id="cd-close-btn"><%= _lcs( 'Schließen' ) %></button>
    </footer>
  </div>
</div>
